import "./LanguageSwitcher.scss";
import { SelectableLinkProps } from "/Models/Generated/SelectableLinkProps";
import cn from "classnames";

interface LanguageSwitcherProps {
  languages: SelectableLinkProps[];
  tabIndex?: number;
}
//TODO: Add lang prop
const LanguageSwitcher = ({ languages, tabIndex }: LanguageSwitcherProps) => {
  return (
    <ul className="language-switcher-norad">
      {languages?.map((language) => (
        <li className="language-switcher-norad__item" key={language.text}>
          <a
            lang={language.lang}
            tabIndex={tabIndex}
            className={cn("language-switcher-norad__link", {
              "language-switcher-norad__link--is-selected": language.selected,
            })}
            href={language.href}
          >
            <span>{language.text}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default LanguageSwitcher;
